// extracted by mini-css-extract-plugin
export default {"toggle":"ShowProductShowcase_toggle__DtSBD","helper":"ShowProductShowcase_helper__p3KYg"};